<!-- Just an image -->
@if (loggedIn()) {
  <nav class="navbar navbar-light bg-white px-3 navbar-expand-lg shadow-sm bg-teal">
    <div class="container">
      <a class="navbar-brand d-flex" routerLink="orderlist">
        <img src="assets/SmileDHBW.png" width="80" alt="Smile CDR" loading="lazy">
        <span class="align-self-end version-label px-2">{{version}}</span>
      </a>
      <button id="navbarhead" class="navbar-toggler" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup" >
        <div class="navbar-nav">
          <a routerLink="provideraccess" class="btn btn-link btn-link-dark">Provider Access API</a>
          <a routerLink="orderlist" class="btn btn-link btn-link-dark">Orders</a>
          <a routerLink="patientlist" class="btn btn-link btn-link-dark">Patients</a>
          <button type="button" (click)="logout()" class="btn btn-link btn-link-dark">Logout</button>
        </div>
      </div>
    </div>
  </nav>
}

<!-- <div id="watermark-container">
<div id="watermark"></div>
</div> -->

<router-outlet></router-outlet>
@if (loggedIn()) {
  <div>
    @if (showLogContent) {
      <div>
        <app-debug-container></app-debug-container>
      </div>
    }
    <div class="fixed-bottom">
      <div class="container-fluid bg-darkgrey p-3 text-light">
        <div class="container d-flex justify-content-between">
          <div class="d-flex my-switch">
            <label class="form-check-label me-3" for="flexSwitchCheckDefault">Debug Logs</label>
            <div>Off</div>
            <div class="form-check form-switch form-check-inline mx-2 d-flex justify-content-center">
              <input id="revenue" class="form-check-input mr-auto"  checked type="checkbox" (change)="showLogs()">
            </div>
            <div>On</div>
          </div>
          <div>
            <span>For Demo Use Only</span>
          </div>
        </div>
      </div>
    </div>
  </div>
}